var login_form = document.querySelector('.login-form');
var recover_form =  document.querySelector('.recover-form');
if(login_form &&  recover_form){
  document.querySelector('.enable-login').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.remove('hide-form');
    recover_form.classList.add('hide-form');
  });
  document.querySelector('.enable-forgot').addEventListener('click',function(e){
    e.preventDefault();
    login_form.classList.add('hide-form');
    recover_form.classList.remove('hide-form');
  });
}
document.querySelectorAll('.edit-address-button').forEach(function(editbutton){
  editbutton.addEventListener('click',function(e){
    e.preventDefault();
    var address_id = this.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach(function(editformdiv){
      if(editformdiv.classList.contains('active-form') && editformdiv.dataset.id != address_id){
        editformdiv.classList.remove('active-form');
      }
    });
    document.querySelector('[data-id="'+address_id+'"]').classList.toggle('active-form');
    document.getElementById('address_form_new').classList.remove('active-open-form');
  });
});
if(document.querySelector('#AddressCountryNew')){
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}
document.querySelectorAll('.destroy_button').forEach(function(destroyButton){
  destroyButton.addEventListener('click',function(e){
    var destroyId = this.dataset.destroy;
    console.log(destroyId);
    Shopify.postLink(
      '/account/addresses/'+destroyId, 
      {'parameters': {'_method': 'delete'}}
    );
  });
});
if(document.querySelector('.account-link')){
  document.querySelector('.account-link').addEventListener('click',function(e){
    document.querySelector('.account-page-active').classList.add('active');
    document.querySelector('.account-left').style.display = 'none';
  });
}
if(document.querySelector('.add-address')){
  document.querySelector('.add-address').addEventListener('click',function(e){
    document.querySelectorAll('.address-edit-form.active').forEach((editForm) => {
      editForm.classList.remove('active-form')
    })
    document.getElementById('address_form_new').classList.toggle('active-open-form');
  });
}
if(document.querySelectorAll('.def_check') != null){
  document.querySelectorAll('.def_check').forEach((defaultAddress) => {
    defaultAddress.addEventListener('click',function(e){
        e.preventDefault();
        console.log('click');
    })
  })
}
if(document.querySelectorAll('.add-back-btn') != null){
  document.querySelectorAll('.add-back-btn').forEach((backBtn) => {
    backBtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelectorAll('.address-edit-form.active-form').forEach((editForm) => {
        editForm.classList.remove('active-form')
      })
      document.getElementById('address_form_new').classList.remove('active-open-form');
    })
  })
}
var sidebar = document.querySelector(".mb-asidebar").offsetTop;
var lastscroll = 0;
window.addEventListener("scroll", () => {
  (window.scrollY >= sidebar) ? document.querySelector('body').classList.add("sidebar-sticky") : document.querySelector('body').classList.remove("sidebar-sticky")
  let scrollcount = window.pageYOffset;
  setTimeout(function(){
    if(scrollcount > lastscroll){
      document.querySelector('.mb-asidebar').style.top = '0px'
    }else if(scrollcount < lastscroll){
      document.querySelector('.mb-asidebar').style.top = document.querySelector('.header-main').clientHeight + 8+'px'
    }
    lastscroll = scrollcount;
  }, 100);
});

document.querySelectorAll('.edit-add .edit-address-button').forEach((edit) => {
  edit.addEventListener('click',function(e){
    window.scrollTo(0, 0);
  })
})
document.querySelectorAll('.ac-address-btn .add-address').forEach((add) => {
  add.addEventListener('click',function(e){
    window.scrollTo(0, 0);
  })
})








